<template>
  <div
    v-if="images"
    class="picture__wrapper"
    :class="classes"
    :style="{
      'background-image':
        !transparent && images?.blurry && `url(${images.blurry})`,
    }"
  >
    <Transition name="fade">
      <div v-show="loaded" v-if="showImage" class="picture">
        <picture>
          <source
            :srcset="largeMedia"
            media="(min-width: 821px)"
            class="image"
          />
          <source
            :srcset="mediumMedia"
            media="(min-width: 429px)"
            class="image"
          />
          <source
            :srcset="smallMedia"
            media="(max-width: 428px)"
            class="image"
          />
          <img
            :src="images.smallMedia"
            :alt="images.altText"
            :width="width"
            :height="height"
            class="image"
            @load="loaded = true"
          />
        </picture>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "Picture",
  inject: ["mq"],
  props: {
    images: {
      type: Object,
      required: true,
    },
    intersected: {
      type: Boolean,
      default: null,
    },
    objectFitCover: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
      hasIntersected: false,
    };
  },
  computed: {
    classes() {
      return {
        "picture__wrapper--cover": this.objectFitCover,
        "picture__wrapper--loading skeleton": !this.loaded,
      };
    },
    showImage() {
      if (this.mq.mdPlus) {
        return true;
      }

      if (this.hasIntersected) {
        return this.hasIntersected;
      }

      if (this.intersected !== null) {
        return this.intersected;
      }

      return true;
    },
    largeMedia() {
      if (this.images.largeMedia2x) {
        return `${this.images.largeMedia} 1x, ${this.images.largeMedia2x} 2x`;
      }
      return this.images.largeMedia;
    },
    mediumMedia() {
      if (this.images.mediumMedia2x) {
        return `${this.images.mediumMedia} 1x, ${this.images.mediumMedia2x} 2x`;
      }
      return this.images.mediumMedia;
    },
    smallMedia() {
      if (this.images.smallMedia2x) {
        return `${this.images.smallMedia} 1x, ${this.images.smallMedia2x} 2x`;
      }
      return this.images.smallMedia;
    },
  },
  watch: {
    intersected(val) {
      if (val) {
        this.hasIntersected = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/skeleton";

.picture__wrapper {
  display: block;
  position: relative;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  &--loading {
    padding-bottom: 150%;
    width: 100%;
  }

  &--cover {
    height: 100%;

    .picture,
    img {
      height: 100%;
    }

    img {
      object-fit: cover;
    }
  }
}

.picture {
  position: relative;
}

.image {
  display: block;
  max-width: 100%;
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
